module.exports = __webpack_public_path__ + "static/media/LPIC-3-303-Security.698bb50e.jpg";